import React from "react";
import { withLocalize } from "react-localize-redux";
import { NavLink ,Link} from 'react-router-dom';

function RecentChatItem(props) {
   
  return (
    <Link to={`/chatservice/${props.regnum}`} href="#" class="widget-list-item">
      <div class="widget-list-media">
      <img src={`api/General/Image/${props.regnum}`} alt=""  class="rounded" />

       </div>
      <div class="widget-list-content">
        <h4 class="widget-list-title">{props.langCode == 'ar' ? props.nameArabic: props.nameEnglish }</h4>
      </div>
    </Link>
  );
}
export default RecentChatItem;



// WEBPACK FOOTER //
// ./src/pages/Chat/RecentChatItem.js